import { render, staticRenderFns } from "./newaffairs.vue?vue&type=template&id=47e949ee&scoped=true&"
import script from "./newaffairs.vue?vue&type=script&lang=js&"
export * from "./newaffairs.vue?vue&type=script&lang=js&"
import style0 from "./newaffairs.vue?vue&type=style&index=0&id=47e949ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e949ee",
  null
  
)

export default component.exports